import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OrderType } from "src/app/shared/models/focusDataModels/OrderType";
import { KitchenOrderTypeOverride, VenueKitchenDevicePreferences } from "src/app/shared/models/VenueKitchenDevicePreferences.entity";

@Component({
	selector: "app-kitchen-order-type-setup",
	templateUrl: "./kitchen-order-type-setup.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class KitchenOrderTypeSetupComponent implements OnInit {
	@Input() kitchenDevicePreferences: VenueKitchenDevicePreferences;
	@Output() kitchenDevicePreferencesChange = new EventEmitter<VenueKitchenDevicePreferences>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	posOrderTypes: OrderType[];

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.getStoreLevelOrderTypes(this.venueService.subscriptionVenue.value.key);
	}

	addOrderTypeSetting() {
		if (!this.kitchenDevicePreferences.orderTypeSettings) {
			this.kitchenDevicePreferences.orderTypeSettings = [];
		}
		this.kitchenDevicePreferences.orderTypeSettings.push(
			new KitchenOrderTypeOverride({
				color: "#56707D",
			})
		);
	}

	deleteOrderTypeSetting(index: number) {
		this.kitchenDevicePreferences.orderTypeSettings.splice(index, 1);
		this.changesToSaveChange.emit(true);
	}

	async getStoreLevelOrderTypes(venueKey: number) {
		const resp = await this.focuslink.posOrderTypeGet(venueKey);
		this.posOrderTypes = resp.map((i) => new OrderType(i));
	}
}
